export default "__VITE_ASSET__Bnpu5wqA__"